/* Existing storefront header; Landing alone has the post-hero CTA. */
(() => {
  if (window.__bfPageNavigation) return window.__bfPageNavigation.refresh();
  let cleanup = () => {};
  function refresh() {
    cleanup();
    const nav = document.querySelector('.section-header');
    if (!nav) return;
    const bar = document.querySelector('[data-bf-sticky-cta]');
    const hero = document.querySelector('.bf-landing-hero');
    const abort = new AbortController();
    const { signal } = abort;
    let observer;
    let pastHero = false;
    const update = () => {
      if (!bar || !hero) return;
      const editing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      const overlay = document.querySelector('header details[open], cart-drawer.active, dialog[open]');
      bar.hidden = !pastHero || !!editing || !!overlay;
    };
    const observe = () => {
      observer?.disconnect();
      const height = nav.getBoundingClientRect().height;
      document.body.style.setProperty('--bf-nav-height', `${height}px`);
      if (!bar || !hero) return;
      pastHero = hero.getBoundingClientRect().bottom <= height;
      update();
      observer = new IntersectionObserver(([entry]) => {
        pastHero = entry.boundingClientRect.bottom <= height;
        update();
      }, { rootMargin: `-${height}px 0px 0px 0px`, threshold: 0 });
      observer.observe(hero);
    };
    const resize = new ResizeObserver(observe);
    resize.observe(nav);
    const mutations = new MutationObserver(update);
    document.querySelectorAll('header details,cart-drawer,dialog').forEach(el => mutations.observe(el, { attributes: true, attributeFilter: ['open','class'] }));
    document.addEventListener('focusin', update, { signal });
    document.addEventListener('focusout', () => requestAnimationFrame(update), { signal });
    observe();
    cleanup = () => { observer?.disconnect(); resize.disconnect(); mutations.disconnect(); abort.abort(); };
  }
  window.__bfPageNavigation = { refresh };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  refresh();
})();
